import { IParamsGetAccounts } from 'app/api/account/model'

export const AccountKeys = {
  allAccounts: ['Accounts'] as const,
  listAccounts: () => [...AccountKeys.allAccounts, 'listAccounts'] as const,
  listAccount: (filter?: IParamsGetAccounts) =>
    [...AccountKeys.listAccounts(), { filter }] as const,
}
